import React from 'react';

import { GoFormzLogoIcon } from '../icons/icons';
import { useAppSelector } from '../hooks/ReduxHooks';
import { ConfigState } from './publicformwhitelabel/PublicFormWhitelabel';

export interface InvalidPublicShareProps {
  errorMessage?: string;
}

export default function InvalidPublicShare(props: InvalidPublicShareProps) {
  const config = useAppSelector<ConfigState>((state) => state.publicFormPersistedState?.configs);

  return (
    <div className="form-editor invalid-public-share">
      {!config?.logoImage && (
        <div className="placeholder-logo">
          <GoFormzLogoIcon />
        </div>
      )}
      <div className="invalid-public-share-header" style={{ backgroundColor: config?.brandColor }}>
        <div className="header-content">
          <div className="logo-section">{config?.logoImage ? <img src={config.logoImage} alt="Logo" className="custom-logo" /> : null}</div>
        </div>
      </div>
      <div className="public-share-invalid-wrapper">
        <div className="invalid-public-share-svg" />
        <div className="main-text">
          <div className="invalid-public-share-message">{props.errorMessage}</div>
        </div>
        {!config && (
          <>
            <div className="line-break"></div>
            <div className="sharing-forms">Interested in sharing your own forms?</div>
            <div className="explore-goformz">
              <a href="https://www.goformz.com/content/pf-signup">Explore GoFormz</a>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
